import { ServiceApi } from "./Api";
import moment from "moment";
import { PedidoPortalService } from "./PedidoPortal";

export class HistoricoAceiteLGPD {

    PostHistoricoAceiteLGPD(usuario) {

        let ip = "";
        let local = "";

        ServiceApi.get('https://api.ipify.org')
            .then(resp => {
                ip = resp;
            });

        navigator.geolocation.getCurrentPosition(
            position => {
                const coords = position.coords;
                local = `Latitude: ${coords.latitude}, Longitude: ${coords.longitude}`;
            }
        );


        let cnt = 0;
        const tm = setInterval(() => {

            cnt++;

            if (cnt === 3)
                ip = "Não foi possível obter IP do usuário";

            if (ip) {
                clearInterval(tm);
                const HistoricoLGPD = 'ACEITE DA POLÍTICA DE PRIVACIDADE DO TZION MYRESULT <br>' +
                    `Usuário: ${usuario.Nome} <br>` +
                    `Data/Hora: ${moment(new Date()).format("DD/MM/YYYY HH:mm:ss")} <br>` +
                    `IP: ${ip} <br>` +
                    `Local (Coordenadas): ${local}`;

                const servicePedido = new PedidoPortalService();

                usuario.AcessoDTO.DadosAcesso = HistoricoLGPD;

                ServiceApi.post(`api/Portal/PostAceiteLGPD`, usuario.AcessoDTO)
                    //servicePedido.getLaudo(usuario.AcessoDTO)
                    .then(resp => {

                        if (resp !== "")
                            return alert('Não foi possível confirmar o ACEITE DA POLÍTICA DE PRIVACIDADE DO TZION MYRESULT. Tente novamente ou contate o administrador.');

                        localStorage.setItem('AceiteLGPD', 'SIM');

                        setTimeout(() => {
                            window.location = "#/portal";
                            window.location.reload();
                        }, 500);

                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }, 500);

    }

    ChecarAceiteLGPD() {
        const aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        if (aceiteLGPD === false) {
            sessionStorage.clear();
            window.location.reload();
        }
    }

}